define('Store.Profile.EntryPoint', [
    'Store.Profile.Tracker',
    'Store.Profile.Model',
    'Tracker',
    'underscore',
    'Store.Profile.Service.Model'
], function StoreProfileEntryPoint(
    ProfileTracker,
    ProfileModelHook,
    Tracker
) {
    'use strict';

    return {
        mountToApp: function mountToApp() {
            ProfileModelHook.hookListeners();
            // For SEO for now use the default store
            if (typeof nsglobal !== 'undefined') {
                ProfileModelHook.setDefaultStore();
            }
            Tracker.getInstance().trackers.push(ProfileTracker);
        }
    };
});
